var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldNotificationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 8a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.66 6.21c-.26-.96-.2-1.88.09-2.7a.99.99 0 0 0-.72-1.3c-1.47-.31-3.06-.3-4.72.15-3.78 1.06-6.67 4.33-7.21 8.22-.92 6.62 4.69 12.23 11.31 11.32 3.9-.54 7.16-3.43 8.21-7.22.46-1.65.47-3.24.16-4.72-.12-.58-.74-.91-1.3-.72-.81.29-1.73.35-2.69.1a4.455 4.455 0 0 1-3.13-3.13z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldNotificationCircle);
export default __webpack_public_path__ + "static/media/vuesax-bold-notification-circle.d44ed7f88d383606dcda907a1bed9dbb.svg";
export { ForwardRef as ReactComponent };